<template>
  <v-row class="pa-2" no-gutters>
         <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
      </v-overlay>

    <v-col cols="12" v-if="showGatewayPopup">
      <qr-edit-gateway
        v-model="showGatewayPopup"
        :sections="specialInfoSingle"
        :form-data="data"
        @edit-all="handleEditAll"
        @save="qrUpdate(false)"
        @cancel="onCancel"
      >
        <template v-slot:preview style="position: relative; min-height: 100%;">
          <v-card
            v-if="resLoading"
            class="d-flex align-center justify-center mt-10"
            flat
            min-height="50vh"
          >
            <v-progress-circular indeterminate size="50" width="5" />
          </v-card>
          <component
            :is="theme"
            v-else
            v-model="data"
            :components.sync="specialInfo"
            :ordered.sync="ordered"
            class="sticky-preview"
            :qr-svg-data-url="qrSvgDataUrl"
          />
        </template>
      </qr-edit-gateway>
    </v-col>
    <template v-if="!showGatewayPopup">
      <v-col
        class="pa-2 sticky-md"
        cols="12"
        md="4"
        style="top: 110px; height: fit-content"
      >
        <v-card
          v-if="resLoading"
          class="d-flex align-center justify-center"
          flat
          min-height="50vh"
        >
          <v-progress-circular
            class="mx-auto"
            indeterminate
            size="50"
            width="5"
          />
        </v-card>
        <component
          :is="theme"
          v-else
          v-model="data"
          :components.sync="specialInfo"
          :ordered.sync="ordered"
          :qr-svg-data-url="qrSvgDataUrl"
        />
      </v-col>

      <v-col class="pa-2 px-0" cols="12" md="8">
        <v-card :disabled="loading" flat>
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-md-12">
                  <p>وارد کردن اطلاعات محصول</p>
                </div>
                <div class="col-md-6 mt-0 pt-0">
                  <div class="rowinfo">
                    <v-text-field
                      v-model="data.visitName"
                      :disabled="e6 > 1"
                      append-icon="mdi-pen"
                      class="mt-0 pt-0 contentinfo"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      dense
                      label="نام محصول شما"
                      outlined
                    />
                  </div>
                </div>
                <div class="col-md-6 mt-0 pt-0">
                  <div class="rowinfo">
                    <qr-address-field
                      id="qr-address"
                      v-model="res.identifier"
                      :domain-id="res.domain_id"
                      :error-messages="errors['identifier']"
                      append-icon="mdi-web"
                      class="mt-0 pt-0 contentinfo"
                      dense
                      :key="$t('qrAddressUpdate.hints.allowedChars')"
                      :hint="$t('qrAddressUpdate.hints.allowedChars')"
                      outlined
                      persistent-hint
                      readonly
                    />
                  </div>
                </div>
              </div>
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
                <div class="mb-4 mx-4">
                    <div class="d-flex align-center">
                      <v-switch
                        v-model="AutoSave"
                        color="primary"
                        class="mt-0 pt-0 shrink"
                        hide-details
                        label="ذخیره خودکار"
                      ></v-switch>
                      <v-tooltip bottom max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            x-small
                            class="mr-1"
                            v-bind="attrs"
                            v-on="on"
                            @click.stop
                          >
                            <v-icon small color="grey darken-1">
                              mdi-help-circle-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>
                          تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                        </span>
                      </v-tooltip>
                    </div>

                    <!-- متن کم‌رنگ و ظریف اختصاصی برای موبایل (زیر سوییچ) -->
                    <div
                      v-if="$vuetify.breakpoint.xsOnly"
                      class="text-caption grey--text text--darken-1 mt-1 pr-1"
                      style="line-height: 1.4"
                    >
                      تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                    </div>
                  </div>

              <list-expansion
                flat
                icon="pencil-ruler"
                single
                title="انتخاب طرح قالب "
                @save-required="AutoSave && qrUpdate(false)"

              >
                <template v-slot:content>
                  <theme-selector2
                    v-model="theme"
                    :components="customTheme"
                    :frames="picFrames"
                  />
                </template>
              </list-expansion>
              <list-expansion
                v-model="data"
                :components="specialInfo"
                :data="data"
                flat
                @save-required="AutoSave && qrUpdate(false)"
              />

              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="qrUpdate(true)"
                />
              </div>
            </v-stepper-content>
          </v-stepper>
        </v-card>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import { Bus } from "@/main";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import NewProCard from "@/view/components/Product/newProCard";
import ListExpansion from "@/view/content/fragments/listExpansion";
import NextBtn from "@/view/content/fragments/nextBtn";
import PrevBtn from "@/view/content/fragments/prevBtn";
import QrCustomize from "@/view/pages/qrland/components/qrCustomize";
import Features from "@/view/pages/product/features";
import ThemeSelector2 from "@/view/pages/product/themeSelector";
import ProductTheme2 from "@/view/pages/product/productTheme2";
import NewDesign from "@/view/pages/product/newDesign";
import QrEditGateway from "../qrland/components/QrEditGateway.vue";
import { mapActions } from "vuex";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "editProduct",

  components: {
    ProductTheme2,
    NewDesign,
    ThemeSelector2,
    QrCustomize,
    PrevBtn,
    NextBtn,
    ListExpansion,
    NewProCard,
    QrAddressField,
    QrEditGateway,
    AtomSpinner
  },

  data() {
    return {
      qrSvgDataUrl:'',
      isAutoSaving: false, 
      AutoSave:false,
      showGatewayPopup: this.$route?.query?.gateway === 'true',
      ordered: [],
      helpData: [],
      serviceName: "Qrland",
      componentName: "editProduct",
      data: {},
      res: {},
      resLoading: false,
      theme: "",
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
      e6: 1,
      errors: {},
      createdId: null,
      shortId: null,
      finish: true,
      loading: false,
      showDialog: false,
      picFrames: [
        { name: "productTheme2", src: "/media/frame/themes/t2.webp" },
        { name: "newProCard", src: "/media/frame/themes/2.svg" },
        { name: "newDesign", src: "/media/bg/product.webp" },
      ],
      customTheme: [
        { name: "newProCard", value: "" },
        { name: "productTheme2", value: "" },
        { name: "newDesign", value: "" },
      ],
      headColor: "linear-gradient(to right , #D81A1AFF, #2115A7FF)",
      bodyColors: "",
      eyeStyle: "",
      qrStyle: "",
      qrSize: "",
      dtUrl: null,
      domainId: null,
      qrShow: 1,
      svgMade: "",
      imageMade: "",
      destinationUrl: "",
    };
  },

  mounted() {
    Bus.$on("colorPalette", (value) => {
      this.data.pallete = value;
    });

    Bus.$on("socialMedias", (value) => {
      this.data.socialMedia = value;
    });

    Bus.$on("uploader", (value) => {
      this.data.photo = value;
    });

    Bus.$on("gradientType", (value) => {
      this.data.isGradient = value;
    });
    this.fetchData();
  },

  provide: {
    provideSingleGallery: false,
    productImageSize: "128",
  },

  computed: {
    specialInfo() {
      return [
        {
          name: "factoryInfo",
          value: "",
          title: this.$t("edit_bpage_special_info_special.factory_information"),
          subtitle: "",
          icon: "account-outline",
          secondName: this.$t("edit_bpage_special_info_special.factory_information"),
        },
        {
          name: "singleProductEditor",
          value: "",
          title: this.$t("edit_bpage_special_info_special.product_information"),
          subtitle: "",
          icon: "information-outline",
          model: "singleProduct",
          secondName: this.$t("edit_bpage_special_info_special.product_information"),
          tabs: [
            {
              title: this.$t("edit_bpage_special_info_special.trust_badge"),
              icon: "mdi-image",
              component: "ArmsChooser",
              model: "arm",
            },
            {
              title: this.$t("edit_bpage_special_info_special.buy_button"),
              icon: "mdi-button-cursor",
              component: "CallToAction",
              model: "btnSetting",
            },
          ],
        },
        {
          name: "customerClubSettings",
          value: "",
          title: this.$t(
            "edit_bpage_special_info_special.customer_club_membership_sms"
          ),
          subtitle: "",
          icon: "cellphone-message",
          model: "customerClub",
        },
        {
          name: "advanceSettings",
          title: this.$t("edit_bpage_special_info_special.smart_settings"),
          icon: "star-settings-outline",
          model: "advanceSettings",
        },
        {
          name: "Features",
          value: "",
          title: this.$t("edit_bpage_special_info_special.add_product_feature"),
          subtitle: "",
          icon: "information-outline",
          model: "Features",
          secondName: this.$t(
            "edit_bpage_special_info_special.product_features"
          ),
        },
        {
          name: "voiceGallery",
          title: this.$t("edit_bpage_special_info_special.add_audio_file"),
          icon: "microphone",
          model: "audiosGallery",
          secondName: this.$t("edit_bpage_special_info_special.audio_gallery"),
        },
        {
          name: "imageUploader",
          value: "",
          title: this.$t("edit_bpage_special_info_special.add_image"),
          subtitle: "",
          icon: "cloud-upload-outline",
          model: "photo",
          secondName: this.$t("edit_bpage_special_info_special.photo_gallery"),
        },
        {
          name: "VideoGallery",
          value: "",
          title: this.$t("edit_bpage_special_info_special.video_gallery"),
          secondName: this.$t("edit_bpage_special_info_special.video_gallery"),
          subtitle: "",
          icon: "video-outline",
        },
        {
          name: "socialMediaIcons",
          value: "",
          title: this.$t("edit_bpage_special_info_special.add_social_media"),
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
          secondName: this.$t("edit_bpage_special_info_special.social_media"),
        },
        {
          name: "colorPallete",
          value: "",
          title: this.$t("edit_bpage_special_info_special.select_color"),
          subtitle: "",
          icon: "format-color-fill",
          model: "pallete",
          secondName: "",
        },
      ];
    },
    domainName() {
      return this.$route.params?.name?.replace('?gateway=true','');
    },
    qrId() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
specialInfoSingle() {
  const descriptionKeys = {
    factoryInfo:
      "edit_product_special_info_single.factory_info_description",

    singleProductEditor:
      "edit_product_special_info_single.single_product_editor_description",

    customerClubSettings:
      "edit_product_special_info_single.customer_club_settings_description",

    advanceSettings:
      "edit_product_special_info_single.advance_settings_description",

    Features:
      "edit_product_special_info_single.features_description",

    voiceGallery:
      "edit_product_special_info_single.voice_gallery_description",

    imageUploader:
      "edit_product_special_info_single.image_uploader_description",

    VideoGallery:
      "edit_product_special_info_single.video_gallery_description",

    socialMediaIcons:
      "edit_product_special_info_single.social_media_icons_description",

    colorPallete:
      "edit_product_special_info_single.color_palette_description",
  };

  return this.specialInfo.map((item) => ({
    ...item,
    description: descriptionKeys[item.name]
      ? this.$t(descriptionKeys[item.name])
      : "",
  }));
},
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID"]),

    // متدهای مربوط به Gateway
    onCancel() {
      this.$router.push({ name: "qr.list" });
    },
    handleEditAll() {
      this.showGatewayPopup = false;
    },

    fetchData() {
      const fixData = (data) => {
        let fixed = { ...data.data };

        // fix singleProduct value
        if (!!fixed?.singleProduct) {
          if (!!fixed.singleProduct.title) {
            fixed.singleProduct.name = fixed.singleProduct.title;
            delete fixed.singleProduct.title;
          }

          if (fixed.singleProduct.content) {
            fixed.singleProduct.description = fixed.singleProduct.content;
            delete fixed.singleProduct.content;
          }

          if (fixed.singleProduct.details) {
            fixed.singleProduct.extra = fixed.singleProduct.details;
            delete fixed.singleProduct.details;
          }
        }
        //

        // fix video gallery
        if (!fixed.VideoGallery) {
          fixed.VideoGallery = {
            title: fixed.VideoGallerySingle?.name || "گالری ویدئو",
            description: "از ویدئوهای مجموع ما دیدن فرمایید.",
            sectionColor: {
              backGround: "",
              text: "",
            },
          };
        }

        if (!fixed.video_gallery) {
          let videos = fixed.VideoGallerySingle?.videos?.map((item) => ({
            name: item.title || "خوش آمدگویی",
            title: "",
            file_link:
              item.url ||
              "https://persian7.asset.aparat.com/aparat-video/1d2d2d8b5fea10b3cbda4fb6e2c45c7653042587-1080p.apt?wmsAuthSign=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjFmMmE5MjgyOWMyZjEzOGNkZmRlMWFlOGU2MzJmNGQxIiwiZXhwIjoxNzE4NDMzMjQ1LCJpc3MiOiJTYWJhIElkZWEgR1NJRyJ9.su36sCl2UH54sLhnn78_dHggUySs2d0CKGs3vW5UTH8",
            description: item.description,
            link: item.link,
          }));

          fixed.video_gallery = [
            {
              name: "گالری",
              images: !!videos?.length
                ? [...videos]
                : [
                    {
                      name: "خوش آمدگویی",
                      title: "",
                      file_link:
                        "https://persian7.asset.aparat.com/aparat-video/1d2d2d8b5fea10b3cbda4fb6e2c45c7653042587-1080p.apt?wmsAuthSign=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjFmMmE5MjgyOWMyZjEzOGNkZmRlMWFlOGU2MzJmNGQxIiwiZXhwIjoxNzE4NDMzMjQ1LCJpc3MiOiJTYWJhIElkZWEgR1NJRyJ9.su36sCl2UH54sLhnn78_dHggUySs2d0CKGs3vW5UTH8",
                      description: "",
                      link: "",
                      id: 15,
                    },
                  ],
            },
          ];
        }

        if (!fixed.audiosGallery)
          fixed.audiosGallery = { audios: [], audioType: "newPlayer" };

        if (Array.isArray(fixed.audiosGallery)) {
          let audios =
            fixed.audiosGallery.length > 0 ? fixed.audiosGallery : [];
          fixed.audiosGallery = {
            audios: audios,
            audioType: "newPlayer",
          };
        }

        if (!!fixed.VideoGallerySingle) delete fixed.VideoGallerySingle;
        //

        // fix photo
        if (!!fixed?.photo && !fixed.photo.background)
          fixed.photo.background = this.$cdnUrl + "/upload/64b2bb1c4ad38.webp";
        //
        if (!!fixed?.photo && fixed.photo.gallery?.length === 0) {
          fixed.photo.gallery = [
            {
              name: "",
              images: [],
            },
          ];
        }
        if (!fixed.companyNumberName) fixed.companyNumberName = "";
        if (!fixed.audiosGallery) fixed.audiosGallery = [];

        return {
          ...data,
          data: fixed,
        };
      };

      this.loading = true;
      this.resLoading = true;

      this.$api
        .get(
          `/v1/testQr/find/${this.domainName}${
            !!this.qrId ? "/" + this.qrId : ""
          }`,
        )
        .then(({ data }) => {
          this.setCreatedQrID(data.data.id);
          this.qrSvgDataUrl= data?.data?.img_url||''; 

          let info = fixData(data.data.data);
          this.data = info.data;
          this.theme =
            info.theme && info.theme.length > 0 ? info.theme : "newProCard";
          this.res = data.data;
          this.ordered = info.ordered || [];
        })
        .finally(() => {
          this.loading = false;
          this.resLoading = false;
        });
    },

  qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      const data = new URLSearchParams();
      data.append("type", "singleProduct");
      data.append("qrType", "dynamic");
      data.append("title", this.res.title);
      data.append("domain", this.res.domain.name);
      data.append("identifier", this.res.identifier);
      data.append("qr_id", this.res.qrId);
      data.append(
        "data",
        JSON.stringify({
          theme: this.theme,
          data: this.data,
          ordered: this.ordered || [],
        }),
      );

      this.$api
        .put("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then(({ data }) => {
          this.finish = final;
          if(final || !this.AutoSave)
              this.$toast.success("محصول شما با موفقیت ویرایش شد.");
          
          if (final) {
            this.$router.push({ name: "qr.list" });
          }
        })
        .catch(({ response }) =>
          console.log("error in get response: ", response),
        )
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false;
        });
    },
  },
};
</script>

<style scoped>
.sticky-preview {
  position: -webkit-sticky;
  position: sticky;
  top: 0px !important; 
  align-self: flex-start;
  height: max-content;
  z-index: 10;
}
</style>
